export const COMMON_TEXT = {
     VALUE_EMPTY: '',
     VALUE_EMPTY_JP_TEXT: 'なし',
     CHECK_SHEET_TITLE: 'チェックシート',
     CHECK_SHEET_SHORT_TIME_TITLE: 'チェックシート（短時間型）',
     CHECK_SHEET_FUNCTIONAL_TRAINING_TITLE: 'チェックシート（機能訓練排泄）',
     BATH_SCREEN: '入浴チェックシート',
     EXCREATION: '排泄チェックシート',
     BATHE_MANAGEMENT: '入浴予定管理',
     BATHING_TITLE: '入浴チェックシート',
     USER_DASHBOARD: '利用者情報シート',
     ITEM_SEARCH: '項目名検索...',
     ALL_SELECTED: '全て選択されている。',
     NO_DATA: 'データがありません。',
     SEARCH: 'タイトルを探す',
     EMPTY_NODE: '(なし)',
     DISPLAY_TARGET: '表示対象',
     DISPLAY_UNIT: '表示ユニット',
     DISPLAY_LAST_SYNC_CHECK_SHEET: '最終更新: ',
     MIN_AGO: ' 分前',
     TUBE_FEEDING: '経管栄養',
     IMAGE:'写真',
     ENTERAL_FEEDING:'経管栄養',
     ALL_SELECT: '全選択',
     ITEM_SELECTED:'{0} 件を選択中',
     ITEM_SELECTED_TV:'件を選択中'
}

export const BUTTON = {
     LOGIN: 'ログイン',
     BACK: '戻る',
     CREATE: '作成',
     DELETE: '削除',
     EDIT: '編集',
     YES: 'はい',
     NO: 'いいえ',
     ADD: '追加',
     SAVE: '保存',
     BATHE_SAVE: '利用者情報を保存',
     CANCEL: 'キャンセル',
     CLOSE: '閉じる',
     NEXT: '次へ',
     CONFIRM: '確定',
}

//--- COMPONENT TEXT ---//
export const LOGIN = {
     ID_LBL: 'ログインID',
     PASSWORD_LBL: 'パスワード',
     ID_REQUIRED: 'ログインIDを入力して下さい',
     CUST_ID_REQUIRED: '顧客IDを入力して下さい',
     PASSWORD_REQUIRED: 'パスワードを入力して下さい',
     CUS_PASS_REQUIRED: 'データベースIDを入力して下さい',
     RESET_PASSWORD_LBL: 'パスワードを忘れた方はこちら',
     LOGIN_ERR_MSG: '入力した内容に誤りがあります。\nもう一度入力してください。',
     LOGIN_CONSOLE_ERR_MSG: '「@carekarte.jp」のメールアドレスでのみログインできます。\nもう一度やり直してください。',
     LOGIN_ERR_500_MSG: 'ログインの処理に失敗しました。',
     TEMPLATE_SETTING: 'テンプレート設定',
     ERR_USER_LOCKED: 'ERR_USER_LOCKED',
     LOGIN_APP: 'CAREMONI',
     BACK_TO_CUST_LOGIN: '別法人にログインするため、<br> 現在ログインしている法人の認証を解除します。<br>再認証には、顧客IDとパスワードの入力が必要です。<br>よろしいですか。'
}

export const OFFICE_SELECTION = {
     LABEL: 'ログインする事業所を選択してください。',
     NO_OFFICE: '通所系、入所系の事業所の所属が無い為、ログイン出来ません。'
}

export const MENU_NAME = {
     HOME: 'チェックシート',
     CHECK_SHEET_SHORT_TIME: 'チェックシート(短時間型)',
     CHECK_SHEET_FUNCTIONAL_TRAINING: 'チェックシート(機能訓練排泄)',
     MENU1: 'SCREEN 1',
     BATH_SCREEN: '入浴チェックシート',
     EXCREATION: '排泄チェックシート',
     TITLE_SETTINGS: '基本設定',
     BATHE_MANAGEMENT: '入浴予定管理',
     MENU4: 'SCREEN 4',
     SETTINGS: 'システム設定',
     USER_DASHBOARD: '利用者情報シート',
     USER_SETTINGS: '画面設定',
}

export const LOGOUT = {
     LBL_LOGOUT: 'ログアウト',
}

export const CHECKSHEETSETTINGDIALOG = {
     SORT_ORDER: '並び順',
     DISPLAY_ORDER: '表示順',
     DISPLAY_COLUMN: '列表示',
     SEPARATE_USERS_BY_SERVICE: 'サービス提供時間ごとに利用者を分ける',
     ASCENDING_START_TIME: '開始時間の昇順',
     ASCENDING_ORDER_ENDTIME: '終了時間の昇順',
     START_TIME_ORDER: '開始時間順',
     END_TIME_ORDER: '終了時間順',
     HIDE_USERS_OUTSIDE: 'サービス提供時間外の利用者を非表示にする',
     HIDE_USERS_LEAVE: 'お休みの利用者を非表示にする',
     BTN_CONFIRM: '確定',
     SETTING_CONFIG: '設定',
     TIME_CHANGE_PAGE:'ページの切り替え時間',
     FLASHING_SWITCHING: '申し送り点滅',
     MARQUEE_SPEED: '申し送り等速度',
     DISPLAY_SETTING_NYUSHO: '表示設定',
     TIME_RANGE_NYUSHO: '表示時間の幅',
     MARGIN_TO_TIME_NYUSHO: '右端から現在時間までの余白',
     DISPLAY_UNIT_NYUSHO: '表示ユニット',
     DISPLAY_GROUP_NYUSHO: '表示グループ',
     SORT_ROOM_NYUSHO: '居室順',
     SORT_NAME_NYUSHO: '氏名順',
     HANDOVER_TIME: '申し送り記録の表示期間',
     HANDOVER_TIME_CHANGE: '申し送りの切り替え時間',
     IMG_SWITCHING_TIME: '画像の切り替え時間',
     CARE_PLAN_SWUTCHING_TIME: 'ケアプランの切り替え時間',
     EXCREATTION_TIME: '経過時間'
}

export const USERDASHBOARDDIALOG = {
    RANGE: '表示設定',
    INTERVAL_TIME: 'システム設定',
    TOTAL_DAY: '申し送り記録の表示期間',
    HANDOVER_INTERVAL_VALUE: '申し送りの切り替え時間',
    IMAGE_INTERVAL_VALUE: '画像の切り替え時間',
    CARE_PLAN_INTERVAL_VALUE: 'ケアプランの切り替え時間',
    DAY: '日',
    SECOND: '秒',
    CONFIRM_BTN: '確定'
}

export const BATHINGDIALOG = {
    OBJECT_FILTERING: '表示設定',
    COLUMN_FILTERING: '列表示',
    TIME_SETTING: '設定',
    UNIT_FILTERING_LBL: '表示ユニット',
    GROUP_FILTERING_LBL: '表示グループ',
    BATH_ROOM_FILTERING_LBL: '表示浴室',
    AUTO_PAGING_TIME: 'ページの切り替え時間',
    CONFIRM_BTN: '確定',
    SECOND: '秒',
    SORT_BATH_ROOM: '入浴順',
}

export const BATH_ROOM_SETTING = {
    BATH_NAME_REQUIRED: '名称を入力してください',
    DELETE_BATH_MSG:'を削除します。\n よろしいですか？',
    CHANGE_BATH:'内容を破棄して移動します。\n よろしいですか？',
    DELETE_SUCCESS:'削除しました。',
    SAVE_SUCCESS:'保存しました。',
    SAVE_FAIL:'保存できません。',
    SAVE_CONFLICT:'他の端末でこの浴室が更新されました。\n 画面を再読み込みしますか？',
    // Single-OK variant of SAVE_CONFLICT: acknowledging always reloads, so it states the reload
    // instead of asking. Used where the conflict dialog offers no decline.
    SAVE_CONFLICT_RELOAD:'他の端末でこの浴室が更新されました。<br>画面を再読み込みします。',
    BATHROOM_DELETED:'他の端末でこの浴室が削除されました。\n 画面を再読み込みします。',
    // 404 DAI_NOT_FOUND from update-bathdai / preview-bathdai-change: the dai is no longer
    // registered in this bathroom (the room still exists), so this speaks about the 利用者, not the
    // room. Acknowledging reloads. Distinct from BATHROOM_DELETED and from a code-less 404 (which
    // shows SAVE_HTTP_FAILED and does not reload).
    DAI_NOT_FOUND_RELOAD:'他の端末でこの利用者の浴室設定が変更されました。<br>画面を再読み込みします。',
    DELETE_CONFLICT:'他の端末でこの浴室が更新されました。\n それでも削除しますか？',
    CAPACITY_REQUIRED: '定員数を入力してください',
    SELECT_BATHROOM_HIERARCHY: '浴室情報を追加したい階層を選択してください。',
    DELETE_DISABLED_HAS_DAI: '浴室を設定している利用者が \n いるため削除できません。',
    // Apply-result dialog: a status summary in the header, then one block per outcome (days grouped
    // by room). The block labels are the status names; conflicted/failed carry the check hint.
    APPLY_RESULT_TITLE: '反映結果',
    APPLY_SUMMARY_SUCCESS: (n: number) => `成功 ${n}件`,
    APPLY_SUMMARY_CONFLICT: (n: number) => `競合 ${n}件`,
    APPLY_SUMMARY_FAILED: (n: number) => `失敗 ${n}件`,
    APPLY_SUMMARY_SUPERSEDED: (n: number) => `上書き ${n}件`,
    APPLY_BLOCK_UPDATED: '更新（移動なし）',
    APPLY_BLOCK_ADDED: '追加',
    APPLY_BLOCK_REMOVED: '削除',
    APPLY_BLOCK_CONFLICTED: '競合',
    APPLY_BLOCK_FAILED: '失敗',
    APPLY_BLOCK_SUPERSEDED: '上書き済み（未反映）',
    APPLY_ROOM_UNKNOWN: '（浴室不明）',
    APPLY_TABLE_ROOM_HEADER: '浴室',
    APPLY_RESULT_EMPTY: '該当する日はありません。',
    APPLY_RESULT_CHECK_HINT: '入浴管理で該当日の内容を確認してください。',
    // Caution under the title, then a legend box explaining each status tab. Each legend row is
    // its coloured labels, the separator, then the description.
    APPLY_RESULT_CAUTION: '反映結果を確認し、必要に応じて手動修正を行ってください。',
    APPLY_LEGEND_SEPARATOR: '・・・',
    APPLY_LEGEND_SUCCESS_LABEL: '成功',
    APPLY_LEGEND_SUCCESS: '入浴予定があるが、移動が発生しなかった日',
    APPLY_LEGEND_CONFLICT: '複数アカウントで同時に更新操作を行い、更新に失敗した日',
    APPLY_LEGEND_FAILED: 'エラーが発生し、更新に失敗した日',
    // Whole-dai failure (DaiNotFound=1), not a per-day count - no date list follows.
    APPLY_RESULT_DAI_NOT_FOUND: '対象の利用者が見つからなかったため、予定へ反映できませんでした。',
    APPLY_PLAN_FAILED: (daiName?: string | null) => daiName
        ? `設定は保存しましたが、${daiName} の既存の予定への反映に失敗しました。入浴管理で予定を確認してください。`
        : '設定は保存しましたが、既存の予定への反映に失敗しました。入浴管理で対象の利用者の予定を確認してください。',
    PREVIEW_UNAVAILABLE: '予定の読み込みに失敗しました。しばらくしてからもう一度お試しください。',
    // Shown for a 400 or 5xx (and a non-throwing non-200) on any bath write - update-bathdai,
    // move-bathdai, preview-bathdai-change, upsert-logs. Neutral because the copy cannot tell
    // whether a retry helps; the behaviour does (5xx keeps the DAI設定 dialog open, 400 closes it).
    // Not reused from SAVE_FAIL, which bath-info uses for input validation. 403, status 0 (offline)
    // and non-HTTP errors are intentionally left silent (decision 2026-09-22).
    SAVE_HTTP_FAILED: '保存できませんでした。'
}

/**
 * Copy for the confirmation dialog shown before a dai edit that changes its room or basic days
 * (ticket CKWEB-2826 mock). Dates are listed as yyyy/MM/dd（曜）.
 */
export const BATH_DAI_CHANGE_CONFIRM = {
    LEAD: '保存済みの入浴予定に対して変更内容を反映します。\n変更箇所を確認のうえ、確定ボタンを押してください。',
    SECTION_IMPACT: 'スケジュールへの影響',
    ROOM_CHANGE: '浴室の変更',
    PATTERN_CHANGE: '基本曜日の変更',
    roomRemoved: (fromRoomName: string) => `削除（${fromRoomName}から除外）`,
    roomAdded: (toRoomName: string) => `追加（${toRoomName}に追加）`,
    PATTERN_REMOVED: '削除（対象外となる日付）',
    PATTERN_ADDED: '追加（新たに対象となる日付）',
    CREATED_TITLE: '手動追加した予定の変更',
    CREATED_LEAD: '変更後浴室へ同日の入浴予定を作成するか選択してください。',
    CREATED_NOTE: 'チェックを外した日は、元の浴室から削除されますが、新しい浴室へ予定は作成されません。',
    CREATED_CHECK_ALL: 'すべて選択',
    NONE: 'なし',
    WEEK_PREFIX: '第',
    WEEK_SUFFIX: '週',
    WEEK_SEPARATOR: '・'
};

export const REPORT_ITEM = {
     PRIORITY_LABEL: 'ヒヤリハット',
     TEMPORATY_LABEL: '臨時与薬'
}

export const USER_DASHBOARD = {
     SCREEN_NAME: '利用者情報シート',
     HANDOVER_LABEL: '申し送り',
     IMAGE_LOG_LABEL: '画像',
     VITAL_LABEL: 'バイタル',
     MOISTURE_LABEL: '水分量',
     BATHER_LABEL: '入浴',
     TRAINING_LABEL: '個別機能訓練',
     EXCRETION_LABEL: '排泄（現在から24時間表記）',
     MEDICINE_LABEL: '薬',
     CARE_PLAN_LABEL: 'ケアプラン',
     MEAL_LABEL: '食事（主/副）',

     CARE_PLAN_LABEL_1: 'ニーズ',
     CARE_PLAN_LABEL_2: '長期目標',
     CARE_PLAN_LABEL_3: '短期目標',
     CARE_PLAN_LABEL_4: 'サービス内容',
     SCREEN_ALIAS: 'USER_DASHBOARD'
}

export const BATH_SCREEN = {
     SCREEN_NAME: '入浴チェックシート',
     SCREEN_ALIAS: 'BATH_SCREEN'
}

export const EXCREATIONSCREEN = {
     PAGE_NAME: '排泄管理表',
     LAST_UPDATE_LBL: '最終更新',
     NONE: '排泄無',
     URINATION: '排尿',
     DEFECATION: '排便',
     TREATMENT: '処置',
     SPECIAL_CARE: '専門ケア',
     HAND_OVER: '申送り',
     MAIN_DISH: '申送り',
     SIDE_DISH: '副食',
     EXCREATION: 'Excreation'
}

export const LocalStorageKey = {
    NYUSHO_ACTIVITY_LOG: 'NyuShoActivityLog',
    LOCK_PAGE_CHECK_SHEET: 'LockPageCheckSheet',
    LOCK_PAGE_BATHING: 'LockPageBathing',
    LOCK_PAGE_EXCREATION: 'LockPageExcreation'
};

export const TopicFirebase = {
    WEB_APP_VERSION: 'webAppVersion',
    TV_APP_VERSION: 'tvAppVersion',
};


export const TITLE_SETTINGS = {
     SCREEN_NAME: 'タイトル設定',
     SYNC_TITLE_BTN: 'タイトル更新',
     LBL_SYNC_TTL_DETAIL: '	設定前にCAREKARTEのスケジュール、記録タイトルを最新に更新してください。',
     YOTEI_LIST: 'スケジュール一覧',
     RECORD_TTL_LIST: 'タイトル一覧',
     FOOTER_NOTED_FIRST: 'ケアモニの利用開始後、CAREKARTEで追加・更新したタイトルを',
     FOOTER_NODED_LAST: '設定したい場合は、1、2の操作を再度行ってください。',
     SAVE_MESSAGE: '保存しました。',
     SYNC_MESSAGE_SUCCESS: '完了しました。',
     SYNC_MESSAGE_ERROR: 'タイトルの取得に失敗しました。',
     LBL_SYNC_ROWONE: 'ケアモニに表示する記録の確認・設定を行うことができます',
     LBL_DATE: '最終取得日時',
     CANCEL_DIALOG:'編集内容を破棄し、表示タイトル設定画面に戻ります',
     CANCEL_DIALOG_TITLE:'追加したタイトル区分を破棄し、表示タイトル設定画面へ戻ります。',
     TITLE_DEFAULT_DIALOG:'追加したタグ情報を削除し、初期値に戻ります。',
     SET_DEFAULT_TITLE_MESSAGE_SUCCESS: '完了しました。',
     SET_DEFAULT_TITLE_MESSAGE_ERROR: 'タイトルの取得に失敗しました。',

}

export const SCREEN_TITLE_CONFIG = {
     CHECK_SHEET: '01',
     BATHE: '02',
     EXCREATIONS: '03',
     USER_DASHBOARD: '04',
     CHECKALL: '全選択',
     HAS_RECORD: 'has_record',
     RESET_TO_DEFAULT:'スケジュール一覧、タイトル一覧に設定した 内容を初期値に戻します。よろしいですか？'
}
export const TV = {
     TV_CORP_LOGIN: '法人番号',
     TV_CUSTID: '顧客ID',
     TV_CUSTPASS: 'データベースID',
     TV_USER_SETTINGS_TITLE: '設定',
     TV_SETTING_CHECKSHEET: 'チェックシート',
     TV_SETTING_CHECKSHEET_SHORT_TIME: 'チェックシート\n（短時間型）',
     TV_SETTING_CHECKSHEET_FUNCTIONAL_TRAINING: 'チェックシート\n（機能訓練排泄）',
     TV_SETTING_EXCREATIONS: '排泄チェックシート',
     TV_SETTING_USER : '利用者情報シート',
     TV_SETTING_BATHE : '入浴チェックシート',
     TV_SETTING_NYUSHO: '表示設定',
     TV_SETTING_COLUMN: '列表示',
     TV_SETTING_CONFIG: '設定',
     TV_SETTING_EMPTY: '選択してください。',
     TV_USER_DB_TITLE: '利用者一覧',
     TV_USER_DB_EMPTY: 'データがありません。',
     TV_USER_DB_CONFIG: 'システム設定',
     TV_SETTING_DEVICE_NAME: 'アプリ情報',
     TV_DEVICE_NAME: 'デバイス名',
     TV_DEVICE: 'デバイス',
     TV_APP_VERSION: 'アプリバージョン',
     TV_WEBVIEW_VERSION: 'Webバージョン',
     TV_LOGIN_OFFICE: 'ログイン組織',
     TV_LOGIN_USER: 'ログインユーザー',
     TV_LAST_LOGIN_DATE: '最終ログイン日時',
     TV_RESET_WEB: 'アプリキャッシュ削除',
}
export const TV_CSS ={
     VISIBLE : 'visible',
     HIDDEN : 'hidden',
}
export const USER_IMGS ={
  MEN : '../../../../../../assets/images/user_men_icon.svg',
  WOMEN : '../../../../../../assets/images/user_icon.svg',
}
export const CHART_COLOR ={
  MEAL_MAIN_YESTERDAY : '#3b7e23',
  MEAL_SUB_YESTERDAY : '#5dc737',
  MEAL_MAIN_TODAY : '#df651f',
  MEAL_SUB_TODAY : '#e98c59',
  MOISTURE_YESTERDAY : '#df651f',
  MOISTURE_TODAY : '#e98c59',  
}
export const TIME ={
  MAX_GET_TIME : 99999999999999,
}

export const BATHE_MANAGEMENT = {
    // upsert-logs refused a day (409 per item): the day was changed on another device after
    // this screen loaded it. On acknowledge this screen's data is reloaded and the table redrawn.
    DAILY_SAVE_CONFLICT: '他の端末でこの浴室が更新されました。<br>画面を再読み込みします。',
    // upsert-logs could not store a day (per-item outcome "failed", or a missing/non-200 response):
    // a server-side failure, not a version race. On acknowledge the screen reloads, same as a
    // conflict, but the wording says the save failed rather than blaming another device.
    DAILY_SAVE_FAILED: '保存に失敗した日があります。<br>画面を再読み込みします。',
    // A dai save from the bathe-edit dialog was refused (409): the room was changed on another
    // device after this screen loaded it. On acknowledge this screen's masters and the shown
    // date's daily logs are reloaded and the table redrawn, then the edit is redone.
    DAI_SAVE_CONFLICT: '他の端末でこの浴室が更新されました。<br>画面を再読み込みします。',
    // Sidebar sections
    WAITING_RESIDENTS_TITLE: '入浴候補者',
    LAST_WEEK_SCHEDULE_TITLE: '短期利用者',

    // Sidebar buttons
    ADJUST_FROM_WEEKLY_SCHEDULE: '週間予定から調整する',
    SELECT_FROM_OTHER_BATHROOMS: '他の浴室の利用者から選ぶ',
    SYNC: 'スケジュールから更新',
    DROP_HERE: 'ここにドラッグ&ドロップ',
    CANT_DROP_HERE: 'ここにはドロップできません。',
    DRAP_DROP_ZONE_LBL: '入浴リストから外す',

    // Secondary sidebar
    BATHROOM_SELECTION_TITLE: '①浴室選択',
    FLOOR_1_LIFT_BATH: '1階 リフト浴',
    FLOOR_1_MACHINE_BATH: '1階 機械浴',
    FLOOR_2_LIFT_BATH: '2階 リフト浴',

    USER_SELECTION_TITLE: '②利用者選択',
    USER_SELECTION_SUBTITLE: '入浴者リストにドラッグ&ドロップしてください。',

    // Date picker
    TODAY_BUTTON: '本日',
    ROOM_SUFFIX: '名',

    // Action buttons
    RESET_BUTTON: 'リセット',

    // Header notes
    DRAG_DROP_NOTE: '・ドラッグ＆ドロップで利用者を入替できます。',
    LONG_PRESS_NOTE: '・利用者名をクリックで入浴情報を編集できます。',

    // Bath types
    BATH_TYPE_NONE: 'なし',
    BATH_TYPE_FIRST: '最初',
    BATH_TYPE_PRIORITY: '優先',
    BATH_TYPE_LAST: '最後',

    // Bath methods
    BATH_METHOD_NORMAL: '普通浴',
    BATH_METHOD_PRIVATE: '個浴',
    BATH_METHOD_CHAIR: 'チェアー浴',
    BATH_METHOD_LIFT: 'リフト浴',
    BATH_METHOD_STRETCHER: 'ストレッチャー浴',
    BATH_METHOD_BED: '臥床浴',
    BATH_METHOD_SHOWER: 'シャワー浴',

    // Table headers
    TABLE_HEADER_NAME: '名前',
    TABLE_HEADER_BATH_METHOD: '入浴方法',
    TABLE_HEADER_LAST_BATH_DATE: '最終入浴日',
    TABLE_HEADER_BASIC_DAY: '基本曜日',
    TABLE_HEADER_NOTES: '処置、注意事項等',
    TABLE_HEADER_HANDOVER: '申し送り',
    TABLE_HEADER_HANDOVER_TSUSHO: '申し送り（前回利用時）',

    // Form placeholders and buttons
    REMARKS_PLACEHOLDER: '入力してください。',
    SAVE_BUTTON: '保存',
    CUSTOMER_SAVE_BTN: '利用者情報を保存',
    EDIT_DIALOG_TITLE: '編集',

    // Gender labels
    GENDER_MALE: '男',
    GENDER_FEMALE: '女',

    // Day of week in Japanese
    DAYS_JP: ['日', '月', '火', '水', '木', '金', '土'],

    // Weekly mode
    RANGE: '週間予定',
    START_OF_WEEK: '週の始まり',
    MONDAY_START: '月曜日',
    SUNDAY_START: '日曜日',

    // Validation messages
    INVALID_DAIBELONG_DATE: 'スケジュールが登録されていないため、移動できません。',
    CONFIRM_DISCARD_CHANGES: '内容を破棄して移動します。<br>よろしいですか?',

    DATE_SAVED: '保存済み',

    // Tooltip content
    SYNC_TOOLTIP_CONTENT_TSUSHO: 'ドラッグ＆ドロップで利用者を入替できます。\n本日の予定は利用者名をクリックで利用者情報を編集できます。\n未保存の場合は、ブラウザの再読み込みで最新のスケジュールが反映されます。',
    SYNC_TOOLTIP_CONTENT_NYUSHO: 'ドラッグ&ドロップで利用者を入替できます。\n本日の予定は利用者名をクリックで利用者情報を編集できます。',
    BATH_TIME_CONFIG_HEADER_TOOLTIP: '以下の場合は、基本曜日の登録が必要です。\n\n・CAREKARTEで入浴介助加算の部品がないスケジュールを使用している\n・CAREKARTEで入浴記録から算定している等、スケジュールの入浴介助加算の部品を使用していない\n\n※スケジュールの入浴介助加算の部品を使用していない場合、\n「タイトル連携設定 ＞ 利用者予定 ＞ 入浴(予定あり)」で\n該当スケジュールの設定を外してください。'
}
export const TOOLTIP ={
     TT_4: "CAREKARTEの最新タイトル情報を手動更新します。タイトル情報は１日１回自動更新されます。",
     TT_9: "表示される記録の種類です。",
     TT_10: `表示対象のタイトルが表示されています。
             タイトル区分>タイトル名>項目名
             設定がない場合は背景が黄色く表示されます。`,
     TT_11: `表示するタイトルを設定します。`,
     TT_12: "表示条件の回答項目が表示されています。",
     TT_13: "回答項目の条件を設定します。",
     TT_15: "空白行に対して初期設定を一括で読み込みます。",
     TT_17: `タイトル設定ダイアログを開く
             表示ダイアログの種類は表示タイトル設定項目一覧/設定ダイアログに記載`,
     TT_19: "回答項目設定画面へ遷移する",
     TT_20: "表示対象の記録があると食事列に○を表示します.",
     TT_21: "表示対象の合計数値を表示します",
     TT_22: `条件を満たす記録が入力さ
             れると、経過時間が「０時間」にリセットされます`,
     TT_101: `表示対象の利用者予定が表示されています。
              予定区分＞予定タイトル
              設定がない場合は背景が黄色く表示されます。`,
     
     TT_301: "表示される帳票の項目です。",
     TT_302: `表示帳票のタイトルが表示されています。
              タイトル区分＞タイトル＞ラベル名
              設定がない場合は背景が黄色く表示されます。`,
     TT_303: "表示する帳票を設定します。",
     TT_305: "空白行に対して初期設定を一括で読み込みます。",

}

export const TOOLTIP_DIALOG=
{
     TT_13:"記録があれば記録の中身に関係なく、連携されます。（記録タイトル内の項目部品を指定しません。",
     TT_14:"選択した#タイトルタグ情報に紐づくタイトルが表示されます",
     TT_15:"選択した#項目タグ情報に紐づく項目が表示されます。",
     TT_16:"#タイトル区分.タイトル名.部品名（項目）の順でタグ名称を表示します。",
     TT_30:"回答があれば回答の中身に関係なく、連携されます。（回答を指定しません。）",
     TT_31:"任意の文字列を含む回答のみ表示することができます",

}